<template>
  <div class="row living-options">
    <card-tabs
      class="col-12 w-100"
      :tabs="[
        {
          label: 'Masterplan',
          id: 'masterplan',
        },
        {
          label: 'Releases',
          id: 'subsections',
        },
        {
          label: 'Lots',
          id: 'properties',
        },
        {
          label: 'Houses',
          id: 'dwellings',
        },
        {
          label: 'Packages',
          id: 'packages',
        },
      ]"
      :active-tab="activeTab"
      @tabClick="navigateToTab"
    >
      <template v-slot:masterplan>
        <LivingOptionsMasterplan></LivingOptionsMasterplan>
      </template>
      <template v-slot:subsections>
        <LivingOptionsSubsections></LivingOptionsSubsections>
      </template>
      <template v-slot:properties>
        <LivingOptionsProperties></LivingOptionsProperties>
      </template>
      <template v-slot:dwellings>
        <LivingOptionsDwellings></LivingOptionsDwellings>
      </template>
      <template v-slot:packages>
        <LivingOptionsPackages></LivingOptionsPackages>
      </template>
    </card-tabs>
  </div>
</template>
<script>
import { camelCase } from "lodash";
import CardTabs from "@/components/Cards/TabsCard";
import LivingOptionsMasterplan from "./LivingOptionsMasterplan";
import LivingOptionsProperties from "./LivingOptionsProperties";
import LivingOptionsDwellings from "./LivingOptionsDwellings";
import LivingOptionsSubsections from "./LivingOptionsSubsections";
import LivingOptionsPackages from "./LivingOptionsPackages";

export default {
  components: {
    CardTabs,
    LivingOptionsMasterplan,
    LivingOptionsProperties,
    LivingOptionsDwellings,
    LivingOptionsSubsections,
    LivingOptionsPackages,
  },

  computed: {
    activeTab() {
      return camelCase(this.$route.name);
    },
  },

  beforeRouteEnter(to, from, next) {
    if (to.path === "/live") {
      next("/live/masterplan");
    } else {
      next();
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (to.path === "/live") {
      next("/live/masterplan");
    } else {
      next();
    }
  },

  methods: {
    navigateToTab(tab) {
      this.$router.push("/live/" + tab);
    },
  },
};
</script>
<style lang="scss">
.living-option,
.subsection,
.property,
.dwelling {
  border-radius: 4px;
  padding: 7px;
  border: 1px solid #d4d4d4;
  margin: 1em 0;
}

.input-filter {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 0.25em 0.75em;
}

.status-option {
  display: flex;
  align-items: center;
  align-content: center;

  &__label {
    margin: 0 0 0 8px !important;
  }
}

.status {
  position: relative;
  border-radius: 6px;
  color: #000;
  display: flex;
  align-items: center;
  padding: 0 0 0 20px;

  &::before {
    position: absolute;
    content: "";
    width: 15px;
    height: 15px;
    border-radius: 50%;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
  }

  &.table-link::before {
    left: 5px;
  }

  &--available::before {
    background: #28a745;
  }

  &--coming-soon::before {
    background: #3378d8;
  }

  &--on-hold::before {
    background: #f38433;
  }

  &--sold::before {
    background: #c82133;
  }

  &--builder-lots::before {
    background: #8c21c8;
  }

  &--not-released::before {
    background: #8d8d8d;
  }
}

.table-link {
  appearance: none;
  background: #e8e8e8;
  border: 1px solid #bebebe;
  border-radius: 999px;
  color: #111;
  overflow: hidden;
  padding: 0.1em 1em;
  text-align: left;
  text-decoration: none;
  width: fit-content;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  &--inactive {
    text-decoration: line-through;
  }

  &.status {
    padding: 0.1em 1em 0.1em 2em;
  }

  &:hover {
    background: #dadada;
    color: #111;
  }

  &:visited {
    background: unset;
    color: unset;
  }
}
</style>
